import { createSlice } from "@reduxjs/toolkit";

const initialPermissions = JSON.parse(sessionStorage.getItem("permissions")) || null;

const initialState = {
  permissions: initialPermissions,
};

export const permissionsReducerInner = createSlice({
  name: "Permissions",
  initialState: initialState,
  reducers: {
    setPermissions(state, action) {
      state.permissions = action.payload;
    },
    clearPermissions(state) {
      state.permissions = null;
    },
  },
});

export const { setPermissions, clearPermissions } = permissionsReducerInner.actions;